import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useBusinessProfileData } from 'src/hooks/data/useBusinessProfileData';
import { useYellowMessenger } from 'src/hooks/useYellowMessenger';
import { getAuth } from 'src/redux/selectors';
import { storage } from 'src/utilities/Storage';

const trackYmTap = () => {
  AnalyticsManager.instance().track(AnalyticsEvent.click_chat_widget, {
    from: 'dashboard',
  });
};

type YellowMessengerProps = {
  showButton: boolean;
};

export const YellowMessenger = ({ showButton }: YellowMessengerProps) => {
  const [shouldAddScript, setShouldAddScript] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState('');
  const { closeChatPopUp, toggleChatPopUp } = useYellowMessenger();
  const auth = useSelector(getAuth);
  const location = useLocation();
  const { data } = useBusinessProfileData();

  const ym = document.getElementById('ymDivCircle');
  const ymNotification = document.getElementById('ym-notification');
  const ymFrameHolder = document.getElementById('ymFrameHolder');
  const { username, email, full_name } = storage.get('auth')?.user ?? {};

  /*
    use this code to filter which page will show ym widget
    for example
    ? const isPageShowYm = location.pathname == PATH.ACCOUNTS.bankAccount;

    or by passing boolean value using props showButton from MainLayout
  */
  const isPageShowYm = showButton;

  useEffect(() => {
    if (data?.phone_number) {
      setPhoneNumber(data?.phone_number);
    }
  }, [data]);

  useEffect(() => {
    if (!auth.isSessionExpired && isPageShowYm) setShouldAddScript(true);
  }, [auth.isSessionExpired, isPageShowYm, location.pathname]);

  useEffect(() => {
    const botId = import.meta.env.VITE_YELLOW_MESSENGER_BOT_ID;
    if (
      isPageShowYm &&
      shouldAddScript &&
      phoneNumber !== '' &&
      username &&
      email &&
      full_name &&
      botId &&
      !document.getElementById('ymDivCircle')
    ) {
      const ymConfig = JSON.stringify({
        bot: botId,
        host: 'https://r2.app.yellow.ai',
        floatingIcon: false,
        hideChatButton: true,
        payload: {
          username: username,
          phone: phoneNumber,
          email: email,
          name: full_name,
          widgetVersion: 'v2',
        },
      });

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
      window.ymConfig = ${ymConfig}

      var e = document.createElement("script");
      e.type = "text/javascript", e.async = !0, e.src = "https://app.yellowmessenger.com/widget/main.js";
      var t = document.getElementsByTagName("script")[0];
      t.parentNode.insertBefore(e, t);`;
      setShouldAddScript(false);
      document.body.appendChild(script);
    }
  }, [
    email,
    full_name,
    isPageShowYm,
    location.pathname,
    phoneNumber,
    shouldAddScript,
    username,
  ]);

  // Adding additional tracker and set zIndex
  useEffect(() => {
    if (ymNotification && ymFrameHolder) {
      ymNotification.style.zIndex = '101';
      ymFrameHolder.style.zIndex = '1001';
      ymFrameHolder.style.marginBottom = '15px';
    }
  }, [ymFrameHolder, ymNotification]);

  useEffect(() => {
    const onClick = () => {
      if (document.body.classList.contains('chat-open')) {
        closeChatPopUp();
      }
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, [closeChatPopUp]);

  const onClickButton = () => {
    trackYmTap();
    toggleChatPopUp();
    if (ym) ym.style.display = 'none';
  };
  return { onClickButton };
};
